import ImageGallery from './ImageGallery.vue';

export default {
    components: {
        'image-gallery': ImageGallery,
    },
};
